import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LocationListComponent,
  LocationCreateComponent,
  LocationDetailComponent,
  LocationEditComponent,
} from './pages';
import { LocationRoutingModule } from './location-routing.module';
import { LocationListEffects, LocationEffects } from './effects';
import { reducers } from './reducers';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { KanziAlertsModule } from '@kanzi-apes/kanzi-alerts';
import { TranslateModule } from '@ngx-translate/core';
import {
  LocationDetailHeaderComponent,
  LocationFormComponent,
} from './components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KanziUiModule } from '@kanzi-apes/kanzi-ui';
import { KanziPrimeUiModule } from '@kanzi-apes/kanzi-prime-ui';
import { LocationsFileComponent } from './components/locations-file/locations-file.component';
import { KanziFloormapUiModule } from '@kanzi-apes/kanzi-floormap-ui';

@NgModule({
  declarations: [
    LocationListComponent,
    LocationDetailComponent,
    LocationCreateComponent,
    LocationDetailHeaderComponent,
    LocationFormComponent,
    LocationEditComponent,
    LocationsFileComponent,
  ],
  imports: [
    CommonModule,
    KanziUiModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    LocationRoutingModule,
    StoreModule.forFeature('locations', reducers),
    EffectsModule.forFeature([LocationListEffects, LocationEffects]),
    KanziAlertsModule,
    KanziPrimeUiModule,
    KanziFloormapUiModule,
  ],
  exports: [
    LocationListComponent,
    LocationDetailComponent,
    LocationCreateComponent,
  ],
})
export class KanziLocationModule {}
